.ux-direct-searchbox {
  display: block;

  .ux-input {
    flex: 1 1 auto;
  }

  .ux-button {
    flex: 0 0 auto;
  }

  .ux-spinner {
    transform: translate(-50%, -50%) scale(0.5);
  }

  &-controls {
    align-items: flex-start;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    position: relative;

    &__spacer {
      flex: 0 0 18px;
    }
  }

  &--disabled,
  &--pending {
    .ux-button,
    .ux-input {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
